import React, { useState } from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import { useStyles } from "./OurSloutionsStyle";
import AnchorLink from "react-anchor-link-smooth-scroll";

const IndustrialSolutions = () => {
  const classes = useStyles();

  const [hovered, setHovered] = useState(false);
  return (
    <Box className={classes.IndustrialMainContainer}>
      <img
        src="OurSloution.png"
        alt="Industrial Structure"
        className={classes.Image}
      />
      <Box>
        <Box className={classes.ContentBox}>
          <Box className={classes.TextItem}>
            <Box className={classes.HeadingRow}>
              <Typography className={classes.Arrow}>➞</Typography>
              <Typography className={classes.TextHeading}>
                Structurer dès la numérisation
              </Typography>
            </Box>
            <Typography className={classes.TextDescription}>
              Dès la numérisation, nous structurons et modélisons vos
              installations pour simplifier l'exploitation future.
            </Typography>
          </Box>

          <Box className={classes.TextItem}>
            <Box className={classes.HeadingRow}>
              <Typography className={classes.Arrow}>➞</Typography>
              <Typography className={classes.TextHeading}>
                Automatiser vos processus
              </Typography>
            </Box>
            <Typography className={classes.TextDescription}>
              Nous développons des outils métiers sur-mesure — plugins,
              modélisations 3D — pour automatiser et fiabiliser vos workflows
              industriels.
            </Typography>
          </Box>

          <Box className={classes.TextItem}>
            <Box className={classes.HeadingRow}>
              <Typography className={classes.Arrow}>➞</Typography>
              <Typography className={classes.TextHeading}>
                Faire vivre la donnée en temps réel
              </Typography>
            </Box>
            <Typography className={classes.TextDescription}>
              Nous connectons les données terrain en temps réel pour faire
              évoluer la maquette jusqu'à en faire un véritable jumeau numérique
              opérationnel.
            </Typography>
          </Box>
        </Box>
        <Box className={classes.LearnMoreButtonWrapper}>
          <AnchorLink
            href="#contactez-nous"
            key="contactez-nous"
            offset="140"
            className={classes.NavContactUsButtons}
          >
            <Button
              className={classes.LearnMoreButton}
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >
              {/* {hovered ? "Envoyez votre message" : "EN  SAVOIR..."} */}
              Contactez-nous
            </Button>
          </AnchorLink>
        </Box>
      </Box>
    </Box>
  );
};

export default IndustrialSolutions;
